import { Patient } from '@dreryk/egabinet-patient-frontend-api';
import {
   MedicalInformation,
   MedicalInformationCreateDraftCommand,
   MedicalInformationRemoveDraftCommand,
   MedicalInformationType,
} from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { Choice } from '@dreryk/watermelon';

type UseMedicalInformationCreateDraftCommandOptions = {
   patientId: Patient['id'];
   medicalInformationType: MedicalInformationType | null;
};

export const useMedicalInformationCreateDraftAction = (
   options: UseMedicalInformationCreateDraftCommandOptions
): UseCqrsCommandResult<MedicalInformation> => {
   return useCqrsCommand(() => {
      const command = new MedicalInformationCreateDraftCommand();
      command.patientId = options.patientId;

      if (options.medicalInformationType) {
         command.type = Choice.of(options.medicalInformationType);
      }
      return command;
   });
};

export const useMedicalInformationRemoveDraftAction = (): UseCqrsCommandResult<void, number> => {
   return useCqrsCommand((medicalInformationId) => {
      const command = new MedicalInformationRemoveDraftCommand();
      command.medicalInformationId = medicalInformationId;
      return command;
   });
};
